import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

const ABSTRACT_BLOCK_TYPES = ['unstyled', 'first-paragraph'];

const PageMeta = props => {
  const { page, titlePrefix, assetPath } = props;
  if (!page) return null;
  const { data } = page;
  const firstTextBlock = page.blocks.find(
    b => ABSTRACT_BLOCK_TYPES.indexOf(b.type) > -1,
  );
  const title = data.title || page.title;
  const image = data.thumbnail || data.previewImage;
  const description =
    data.description ||
    data.abstract ||
    (firstTextBlock && firstTextBlock.text);

  return (
    <Head>
      <title>
        {titlePrefix}
        {title}
      </title>
      <meta name="description" content={description} />
      <meta name="author" content={data.author} />
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={description} />
      {image && <meta property="og:image" content={`${assetPath}/${image}`} />}
    </Head>
  );
};

PageMeta.propTypes = {
  page: PropTypes.object.isRequired,
  titlePrefix: PropTypes.string,
  assetPath: PropTypes.string,
};

PageMeta.defaultProps = {
  titlePrefix: null,
  assetPath: '/ada-assets',
};

export default PageMeta;
